<div class="card-body zsd_rd_container" id="zsdrequestdetail">
  <div class="cust_horizontal_rule_top"></div>
  <div class="row">
    <!-- Column 1 -->
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.openDate' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0"> {{ requestInfo.createdDate }}</span>
      </div>

      <div class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.itemCategory' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.category }}</span>
      </div>

      <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.requestor' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.requestor }}</span>
      </div>

      <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.priority' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.priority }}</span>
      </div>

      <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.room' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.room }}</span>
      </div>
      <div *ngIf="requestCustomfield[1]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[1]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[1]?.value | linkify"></span>
      </div>

      <div *ngIf="requestCustomfield[3]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[3]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[3]?.value | linkify"></span>
      </div>


      <div *ngIf="requestCustomfield[5]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[5]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[5]?.value | linkify"></span>
      </div>

      <div *ngIf="requestCustomfield[7]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[7]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[7]?.value | linkify"></span>
      </div>


      <div *ngIf="requestCustomfield[9]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[9]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[9]?.value | linkify"></span>
      </div>



    </div>

    <!-- Column 2 -->
    <div class="col-lg-6 col-md-6 col-sm-12">

      <div class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.closedDate' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0"> {{ requestInfo.closedDate }}</span>
      </div>

      <div class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.itemType' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.itemType }}</span>
      </div>

      <div class="mb-1 row" id="custom_row" *ngIf="showTechnician">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.technician' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.technician }}</span>
      </div>


      <div class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ 'RequestDetail.classification' | translate }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0">{{ requestInfo.classification }}</span>
      </div>


      <div *ngIf="requestCustomfield[0]" class="mb-1 row" id="custom_row">
        <label class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[0]?.displayName + ":" }}
        </label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[0]?.value | linkify"></span>
      </div>

      <div *ngIf="requestCustomfield[2]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[2]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[2]?.value | linkify"></span>
      </div>


      <div *ngIf="requestCustomfield[4]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[4]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[4]?.value | linkify"></span>
      </div>


      <div *ngIf="requestCustomfield[6]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[6]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[6]?.value | linkify"></span>
      </div>


      <div *ngIf="requestCustomfield[8]" class="mb-1 row" id="custom_row">
        <label
          class="zsd_rd_label col-lg-4 col-md-6 col-sm-4 col-5">{{ requestCustomfield[8]?.displayName + ":" }}</label>
        <span class="col-lg-8 col-md-6 col-sm-8 col-7 p-0" [innerHTML]="requestCustomfield[8]?.value | linkify"></span>
      </div>
    </div>

  </div>
  <div class="row" *ngFor="let row of customFormField; let i =index">
    <div class="col-lg-6 col-md-6 col-sm-12 col-12" id="customform_row" *ngFor="let customFormField of matrix[i]">
      <div class="col-lg-4 col-md-6 col-sm-4 col-5 ">{{customFormField.displayName}}:</div>
      <div class="col-lg-8 col-md-6 col-sm-8 col-7 customformvalue">{{customFormField.value}}</div>
    </div>
  </div>

  <div class="cust_horizontal_rule_bottom"></div>
  <div class="row" id="description_row">

    <div class="col-12">
      <label class="zsd_rd_label">{{ 'RequestDetail.description' | translate }}</label>
    </div>

    <div *ngIf="requestInfo.description" class="col-12">
      <span [attr.id]="'requestInfo.description' + index"
        [innerHTML]="currentText">
      </span>
      <span><a *ngIf="requestInfo.description.length >= maxLength" id="more_less_link" (click)="toggleView()"><span
            *ngIf="isCollapsed">{{ 'RequestDetail.more' | translate }}</span></a>
        <a *ngIf="requestInfo.description.length >= maxLength" id="more_less_link" (click)="toggleView()"> <span
            *ngIf="!isCollapsed">{{ 'RequestDetail.less' | translate }}</span> </a>
      </span>
    </div>
  </div>

  <!-- Adding Editable and Non Editable Mode of User Interface for LoggedIn User Name, CC Field, TinyMCE, File Upload-->
  <form *ngIf="selectedAction && isNotNoActions()" (ngSubmit)="updateRequest()" [formGroup]="requestDetailsForm" [attr.id]="'requestdetail-form' + index">
    <div class="row mt-2" id="action_fields">
      <div class="col-lg-2 col-md-2 col-xl-2 col-sm-12 col-12">{{ currentLoggedInUserFullName }}</div>
      <div class="col-lg-10 col-md-10 col-xl-10 col-sm-12 col-12 text-right">
        <div id="action_buttons">
          <button type="button" class="btn zsd_button" id="zsd_cust_button_note_cancel" (click)="cancelUpdateRequest()"
            style="max-width:15rem;">{{'RequestDetail.cancel' | translate}}</button>
          <button type="submit" class="btn zsd_button" id="zsd_cust_button_note_send"
            style="max-width:15rem;">{{'Actions.'+selectedAction | translate}}</button>
        </div>
      </div>
    </div>

    <div class="row" id="cc_field" *ngIf="showNotify">
      <div class="col-lg-1 col-md-1 col-xl-1 col-sm-12 col-12 text-left">{{'RequestDetail.cc' | translate}}</div>
      <div class="cc_input_field col-lg-11 col-md-11 col-xl-11 col-sm-12 col-12">
        <div class="cc-area">
          <div class="cc-details" (click)="setFocusToCCField();">
            <div class="selected-user" *ngFor="let user of ccList;let i=index">
              <span>{{getUserDisplayString(user)}}<span id="remove_icon" class="icon-cancel-circle"
                  (click)="removeFromCCList(i)"><em class="fas fa-times-circle"></em></span></span>
              <!-- <button class="btn btn-info btn-sm remove-user-btn" type="submit" (click)="removeFromCCList(i)">&times;</button> -->
            </div>
            <div>
              <input [attr.id]="'input-user' + index" type="text" class="form-control input-user"
                aria-describedby="ccField" [formControl]="ccField" (keydown)="ccListKeyPressAction($event)"
                autocomplete="off">
              <div *ngIf="ccField?.value?.length > 1" class="searchList" id="requestdetail-search-list" (scroll)="scrollEndForCustomerSearch()">
                <span *ngIf="usersLoading">{{'RequestDetail.loading' | translate}}</span>
                <a [attr.id]="'user' + i + index" class="dropdown-item" [ngClass]="{'active-element-in-list': i === currentCcUserIndex}" (click)="addToCCList(user);"
                  *ngFor="let user of userSearchInfo.results; let i = index">{{getUserDisplayString(user)}}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12" id="customtinymce">
      <zsd-tinymce [parentForm]="requestDetailsForm" [attr.id]="'tinymce'  + index" [required]="isNoteMandatory()"
        [requiredError]="'RequestDetail.noteRequired' | translate"></zsd-tinymce>
      <div *ngIf="isLoading" id="spinner" role="progressbar">
        <zsd-spinner class="perform_action_spinner"></zsd-spinner>
      </div>
    </div>

    <div class="col-lg-12 col-md-12 col-xl-12 col-sm-12 col-12">
      <zsd-fileupload (isformValid)="isfileuploadformvalid($event)" (filesSelected)="selectedFilesList($event)">
      </zsd-fileupload>
    </div>
  </form>


  <div *ngIf="requestInfo.solutionId || (requestInfo.solutionText && requestInfo.solutionText !== null)">
    <div class="cust_horizontal_rule_bottom"></div>
    <div class="row" id="solution_row">
      <div class="col-12">
        <label class="zsd_rd_label">{{ 'RequestDetail.solution' | translate }}</label>
      </div>
      <div *ngIf="requestInfo.solutionText" class="col-12"
        [innerHTML]="requestInfo.solutionText">
      </div>
      <div *ngIf="requestInfo.solutionId" class="col-12">
        <a [routerLink]="[showKbaPage(requestInfo)]" (click)='increaseSolutionViewCount(requestInfo.requestNumber)'>
          {{ viewRequestSolutionString(requestInfo.isSolutionWorkAround) | translate }}
        </a>
      </div>
    </div>
  </div>

  <div *ngIf="requestNotesResponse.length > 0" class="col-12 pl-3 pr-3 mt-2">
    <div class="zsd_notes_label">
      <label class="zsd_rd_label ml-2">{{ 'RequestDetail.notes' | translate }}</label>
    </div>
  </div>

  <div class="row card" id="notecard" *ngFor="let notes of requestNotesResponse;let i=index">
    <div class="col-12 mt-1" id="note_label">
      <span class="zsd_rd_noteby">{{notes.noteBy}}</span>
      <span class="zsd_rd_note_date">{{notes.noteAddedDate}}</span>
      <span *ngIf="notes.hasAttachment" style="float:right; right: 10; cursor:pointer;"
        (click)="requestDetailAttachment(i)" data-toggle="modal" [attr.data-target]="'#zsd-attachment_detail'+index"
        class="fa fa-paperclip"> </span>
    </div>
    <div class="col-12 mt-2 zsd_note_container">
      <span [innerHTML]="notes.note"></span>
    </div>
  </div>
  <!-- Attachment Modal -->
  <div class="modal" [attr.id]="'zsd-attachment_detail' + index">
    <div class="modal-dialog modal-dialog-centered modal-md">
      <div class="modal-content" id="modal_content_override">
        <div class="modal-header" id="attachment-header">
          <div id="attachment_header_text">{{ 'RequestDetail.attachments' | translate }}</div>
          <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>
        <div class="modal-body" id="modal_body_override_inner">
          <!-- Spinner -->
          <zsd-spinner *ngIf="attachmentIsLoading || attachmentSpinnerStart" id="spinner" role="progressbar" class="custom-spinner">
          </zsd-spinner>
          <div *ngFor="let attachment of reqNotesAttachmentResponse" class="attachment-detail">

            <div class="attachment-name">
              <a id="attachment_link_text" (click)="attachmentDetails(attachment)">{{attachment.attachmentName}}</a>
            </div>
            <div>
              <span>{{attachment.attachmentSize}}</span>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- End of Attachment Modal -->
</div>